import styled from '@emotion/styled';
import { animated } from 'react-spring';

export const CartContainer = styled(animated.div)`
  width: 100%;
  height: 100vh;
  will-change: transform;
  @media (min-width: 768px) {
    max-width: 464px;
  }
`;
